import { ApplicationInsightsMonitorService } from '@services/monitor/application-insights-monitor.service';

export function initializeApplicationInsights() {
  return () => {
    const appInsights = new ApplicationInsightsMonitorService();
    try {
      /**
       * track application startup
       */
      appInsights.trackEvent('Application_Startup', {
        timestamp: new Date().toISOString(),
      });

      return Promise.resolve();
    } catch (error) {
      appInsights.trackException({
        exception: error as Error,
        properties: {
          phase: 'APP_INITIALIZING_AT_APPLICATION_INSIGHTS',
          context: 'Application Startup',
        },
      });
      return Promise.reject(error);
    }
  };
}
